export default "__VITE_ASSET__DcmNuLsc__"